// extracted by mini-css-extract-plugin
export var carrierIcon = "_xu-0";
export var carrierLogo = "_xu-1";
export var detailsSection = "_xu-2";